import script from "./MyConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./MyConfig.vue?vue&type=script&setup=true&lang=js"

import "./MyConfig.vue?vue&type=style&index=0&id=224e5eb8&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-224e5eb8"]])

export default __exports__